import React from "react";
import { Clock3 } from "lucide-react";
import photolg from "../../assets/img/photo-1.jpg";
import { surveyPhoto, handlePhotoError } from "../../utils/profilePhoto";
import star from "../../assets/img/star.svg";

const formatPostedDate = (dateString) => {
  if (!dateString) return "18 Min Ago";

  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;

  if (Number.isNaN(diffMs)) return "18 Min Ago";

  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 60) return `${Math.max(1, diffMins)} Min Ago`;
  if (diffHrs < 24) return `${diffHrs} ${diffHrs === 1 ? "Hr" : "Hrs"} Ago`;
  if (diffDays < 7) return `${diffDays} ${diffDays === 1 ? "Day" : "Days"} Ago`;

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const archivedFallback = {
  title: "How Do Remote Teams Choose Async Collaboration Tools?",
  description:
    "Help Map What Drives Adoption Across Startups And Distributed Product Teams. Results Will Be Shared With The Community This Week.",
  tags: [],
  rewardCoins: 25,
  authorName: "Survey creator",
  authorRole: "Product Researcher",
  duration: "Time unavailable",
};

const ArchivedSurveys = ({ surveys = [], loading, hasMore, onLoadMore }) => {
  return (
    <>
      {surveys.map((item) => {
        const coverImage = item.survey_image && item.survey_image !== "string" ? item.survey_image : photolg;
        const tags = [item.sector_name || item.sector, item.industry_name || item.industry, item.country_name || item.country]
          .filter((value) => value && !/^\d+$/.test(String(value)));
        const visibleTags = tags.length ? tags : archivedFallback.tags;
        const rewardCoins = Number(item.reward_per_participant) || archivedFallback.rewardCoins;

        return (
          <div className="post-card my-survey-archive-card mb-4" key={item.id}>
            <div className="d-flex align-items-center mb-3">
              <img src={surveyPhoto(item)} onError={handlePhotoError} alt="" className="post-user-img" />

              <div className="ms-3">
                <h5 className="ft-15 fw-bold mb-1">{item.author_name || archivedFallback.authorName}</h5>
                <p className="ft-12 mb-0">
                  {item.author_role || archivedFallback.authorRole} <span>-</span> {formatPostedDate(item.updated_on || item.created_on)}
                </p>
              </div>
            </div>

            <div className="position-relative mb-4">
              <img src={coverImage} alt={item.survey_title || archivedFallback.title} className="post-banner" />

              <div className="reward-badge ft-11 d-flex gap-2 align-items-center">
                <img src={star} alt="star" /> Reward: {rewardCoins} Coins
              </div>
            </div>

            <h2 className="post-title fw-bold mb-3 ft-20">
              {item.survey_title || archivedFallback.title}
            </h2>

            <p className="post-desc ft-12 mb-3">
              {item.survey_description || archivedFallback.description}
            </p>

            <div className="d-flex flex-wrap gap-2 mb-4">
              {visibleTags.map((tag, index) => (
                <span className="tag-box" key={`${tag}-${index}`}>
                  #{tag}
                </span>
              ))}
            </div>

            <div className="d-flex align-items-center gap-2 color858c95 ft-12 mb-4">
              <Clock3 size={16} />
              <span>{item.estimated_time || archivedFallback.duration}</span>
            </div>

          </div>
        );
      })}

      {hasMore && (
        <div className="d-flex justify-content-center my-4">
          <button
            className="redhoverbtn px-4 py-2 bgwhite rounded-2 border border-1"
            onClick={onLoadMore}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}
    </>
  );
};

export default ArchivedSurveys;
